import * as types from '../types'

const state = {
  loading: 0,
  zoom: 14
}

const getters = {
  loading: state => state.loading,
  zoom: state => state.zoom,
  position: state => state.position,
  visible: state => state.visible
}

const mutations = {
  [types.COM_LOADING] (state, bool) {
    if (state.loading === 0 && !bool) {
      return
    }
    state.loading = bool ? ++state.loading : --state.loading
  },
  [types.COM_ZOOM] (state, size) {
    state.zoom = size
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/com.js